import React, { useState } from 'react';

interface Tab {
  id: string;
  label: string;
  icon?: React.ReactNode;
  content: React.ReactNode;
}

interface TabsProps {
  tabs: Tab[];
  activeTabId?: string;
  onChange?: (id: string) => void;
  tabPosition?: 'top' | 'left';
  variant?: 'underline' | 'pills';
  className?: string;
}

export const Tabs = ({ tabs, activeTabId, onChange, tabPosition = 'top', variant = 'underline', className = '' }: TabsProps) => {
  const [internalActiveTab, setInternalActiveTab] = useState(tabs[0]?.id);
  const activeId = activeTabId || internalActiveTab;

  const handleTabClick = (id: string) => {
    setInternalActiveTab(id);
    if (onChange) onChange(id);
  };

  const isLeft = tabPosition === 'left';
  const isPills = variant === 'pills';

  return (
    <div className={`flex flex-col lg:${isLeft ? 'flex-row' : 'flex-col'} w-full gap-6 ${className}`}>
      <div className={`flex overflow-x-auto custom-scrollbar ${isLeft ? 'lg:flex-col lg:space-y-2 lg:w-48 lg:shrink-0 flex-row space-x-4 border-b border-slate-100 lg:border-none' : 'flex-row space-x-6 border-b border-slate-100'}`}>
        {tabs.map((tab) => {
          const isActive = activeId === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => handleTabClick(tab.id)}
              className={`
                flex items-center gap-2 px-4 py-3 text-sm font-bold transition-all duration-200 whitespace-nowrap
                ${isLeft ? 'lg:rounded-xl text-left border-b-2 lg:border-b-0' : isPills ? 'rounded-lg' : 'border-b-2 -mb-px'}
                ${isActive 
                  ? isPills ? 'text-[#8dc63f] bg-[#8dc63f]/10/50' : 'text-[#8dc63f] border-[#8dc63f] bg-[#8dc63f]/10/50' 
                  : isPills ? 'text-slate-400 hover:text-slate-600 hover:bg-slate-50' : 'text-slate-400 border-transparent hover:text-slate-600 hover:bg-slate-50'}
              `}
            >
              {tab.icon && <span className="w-4 h-4">{tab.icon}</span>}
              {tab.label}
            </button>
          );
        })}
      </div>
      <div className={`flex-1 animate-in fade-in slide-in-from-bottom-2 duration-300 ${isLeft ? 'lg:pl-6 lg:border-l lg:border-slate-100' : ''}`}>
        {tabs.find((t) => t.id === activeId)?.content}
      </div>
    </div>
  );
};



